import { color, semantic } from '../../../theme/dtl-tokens';
import { typography } from '../../../theme/typography';

// ─────────────────────────────────────────────────────────────────────────────
// TOKENS SEMÁNTICOS — Módulo Avatar Studio
// Mapeo de propósito sobre el DTL global. Si el diseño cambia, solo tocamos acá.
// ─────────────────────────────────────────────────────────────────────────────

export const C = {
  // Layout
  appBg: '#F7F7F8',
  bg: color.base.white,
  surface: color.grey[50],

  // Borders
  border: semantic.border.secondary,        // grey.200
  borderHi: semantic.border.primary,        // grey.500

  // Text
  textPrimary: semantic.text.primary.default,      // grey.800
  textSecondary: semantic.text.secondary.default,   // grey.500
  textMuted: color.grey[300],
  textDisabled: semantic.text.primary.disabled,     // grey.400
  textLabel: color.grey[400],

  // Accent (violeta DTL — selecciones, active states, badges)
  accent: color.purple[500],                // #7A0CFF
  accentLight: color.purple[400],           // #953DFF
  accentSurface: color.purple[0],           // #F2E7FF80
  accentBorder: semantic.border.accent,     // purple.200
  accentText: semantic.text.accent.default, // purple.500

  // Danger / Error
  danger: semantic.text.error.default,      // red.600
  dangerSurface: semantic.background.error, // red.50
  dangerBorder: semantic.border.error,      // red.300

  // Success
  success: semantic.text.success.default,   // green.600
  successSurface: semantic.background.success,

  // Warning
  warning: semantic.text.warning.default,   // orange.600
  warningSurface: semantic.background.warning,

  // Info
  info: semantic.text.link.default,         // blue.600
  infoSurface: semantic.background.info,

  // Panel
  panelBg: color.base.white,
  panelBorder: color.grey[100],
  panelSelectedBg: color.purple[0],
  panelSelectedText: color.purple[500]
} as const;

// ─────────────────────────────────────────────────────────────────────────────
// BOTONES — variantes semánticas
// ─────────────────────────────────────────────────────────────────────────────

export const BTN = {
  primary: {
    bg: color.purple[500],
    text: color.base.white
  },
  secondary: {
    bg: color.purple[0],
    text: color.purple[500]
  },
  ghost: {
    bg: color.grey[0],
    text: color.grey[500]
  }
} as const;

// ─────────────────────────────────────────────────────────────────────────────
// TIPOGRAFÍA
// ─────────────────────────────────────────────────────────────────────────────

export const FONT = typography.fontFamilies.inter;
export const FONT_BRAND = typography.fontFamilies.dmSans;
